import { RowClassParams } from 'ag-grid-enterprise'
import { t } from 'i18next'
import { renderPeriod } from '../../../../../../components/Table/utils'
import { CustomReportVariable } from '../../../../../../redux/context/customReports/typesVariable'
import { getColumnColor, getTitleByLanguage } from '../../customReportTable/utils'
import { CustomReportCategory } from '../../../../../../redux/context/customReports/typesCategory'
import { getBlendedBackgroundColor } from '../../../../../../utils/color.utils'

// utils/renderingUtils.ts
export const renderVariableTitle = (row: CustomReportVariable, variables: CustomReportVariable[]) => {
  let str = getTitleByLanguage(row)
  if (row.params?.dimension) str = str?.concat(` - ${row.params?.dimension?.name}`)
  if (row.params?.dataType) str = str?.concat(` - ${t(`global:${row.params?.dataType}`)}`)
  if (row.period && renderPeriod(row, variables || [])) {
    str = str?.concat(` (${t(`formulaPeriod:${row.period}`)})`)
  }
  return str
}

export const getRowStyle = (params: RowClassParams<CustomReportVariable>) => ({
  fontWeight: params.data?.style?.fontWeight ? 'bold' : 'normal',
  fontStyle: params.data?.style?.fontStyle || 'normal'
})

export const getCellBackgroundColor = (
  category?: CustomReportCategory,
  variable?: CustomReportVariable,
  value?: number
) => {
  const columnColor = getColumnColor(category, variable, value)
  const rowColor = variable?.style?.color

  return getBlendedBackgroundColor(columnColor, rowColor, 'multiply')
}
